import { render, staticRenderFns } from "./WorkTypesItem.vue?vue&type=template&id=b4788a42&"
import script from "./WorkTypesItem.vue?vue&type=script&lang=js&"
export * from "./WorkTypesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports